import React, { useState, useRef } from 'react'
import { toast } from 'react-toastify'
import { Disabler, Spinner, Form } from 'lib/ui'
import { useCheckout, usePaymentMethod } from 'lib/modules/checkout'
import { creditCardFormSchema, creditCardFormValidation } from 'scenes/CustomerDashboard/scenes/Payment/scenes/CommerceHubAdd/schema'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { useCommerceHub, useCommerceHubTokens, CommerceHubCreditCardForm } from 'lib/modules/commercehub'
import { PaymentToken } from 'lib/core/data/customer/paymentTokens/types'
import { Formik } from 'formik'
import { Container } from './styled'
import { useIntl } from 'react-intl'

export const CommerceHub = () => {
  const { paymentTokens, tokensLoading } = useCommerceHubTokens()
  const tokenOptions = getTokenOptions(paymentTokens)
  const [token, setToken] = useState('')
  const intl = useIntl()
  const validation = creditCardFormValidation(intl)
  const handleSubmit = () => {
    // void
  }
  const {
    loading,
    placeVaultOrder,
    placeCardOrder
  } = useCommerceHub()
  const formikRef = useRef<any>(null)

  usePaymentMethod(({ placeOrder }) => {
    if (token) {
      placeVaultOrder({
        publicHash: token,
        onError: () => {
          toast(() => (
            <Failure
              messageId='app.whoops'
            />
          ), {
            autoClose: 15000
          })
        }
      })
    } else {
      const cardValues = formikRef.current?.values
      placeCardOrder({
        ...cardValues,
        onError: () => {
          toast(() => (
            <Failure
              messageId='app.whoops'
            />
          ), {
            autoClose: 15000
          })
        }
      })
    }
  })

  if (tokensLoading) {
    return (
      <Container>
        <Spinner />
      </Container>
    )
  }

  return (
    <Container>
      <Formik
        innerRef={formikRef}
        initialValues={{
          ...creditCardFormSchema
        }}
        validate={validation}
        onSubmit={handleSubmit}
      >
        <>
          {Boolean(paymentTokens?.length) && (
            <Form.Select
              label='Card'
              options={tokenOptions}
              form={{}}
              field={{
                name: 'publicHash',
                value: token,
                onChange: (e) => {
                  setToken(e.target.value)
                }
              }}
            />
          )}

          {!token && (
            <Disabler disabled={loading}>
              <CommerceHubCreditCardForm />
            </Disabler>
          )}
        </>
      </Formik>
    </Container>
  )
}

const getTokenOptions = (paymentTokens: PaymentToken[] = []) => {
  const tokenOptions = paymentTokens.map(paymentMethod => {
    const { type, maskedCc, expirationDate, cardholderName } = paymentMethod.details
    return {
      value: paymentMethod.publicHash,
      label: `${type} - ${maskedCc} (${expirationDate}) - ${cardholderName}`
    }
  })

  tokenOptions.unshift({
    value: '',
    label: 'New Card'
  })

  return tokenOptions
}
